<template>
  <v-chip
    v-if="hasNps"
    x-small
    dark
    :color="color"
    class="contract-nps-chip font-weight-bold"
    @click="$emit('open')"
  >
    {{ label }}
  </v-chip>
  <v-chip
    v-else
    x-small
    outlined
    class="contract-nps-chip grey--text text--darken-1"
    @click="$emit('open')"
  >
    Sin NPS
  </v-chip>
</template>

<script>
import { formatNps, npsColor } from '../utils/nps.utils';

/**
 * Current NPS of a contract in the Contratos table: just the number, with its
 * color, or "Sin NPS". Always clickable, because the modal it opens also
 * shows the history of non-active contracts.
 */
export default {
  name: 'ContractNpsChip',
  props: {
    summary: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasNps() {
      return Boolean(this.summary) && typeof this.summary.nps === 'number';
    },
    color() {
      return this.hasNps ? npsColor(this.summary.nps) : null;
    },
    label() {
      return this.hasNps ? formatNps(this.summary.nps) : 'Sin NPS';
    }
  }
};
</script>

<style scoped>
.contract-nps-chip {
  cursor: pointer;
}
</style>
